import { useQuery } from '@hooks/reactQuery';

import { getKaiNotAssignedUsers } from '@api/kaiAssistants';

import { extractQueryParams } from '@utils/common';

import { IShortUserInfo } from '@interfaces/user/user';

import { GET_KAI_NOT_ASSIGNED_USERS } from '@constants/queryKeys';

export interface KaiNotAssignedUsersReturned {
	kaiNotAssignedUsers: IShortUserInfo[];
	isLoadingKaiNotAssignedUsers: boolean;
}

export function useQueryKaiNotAssignedUsers(organisationId: string): KaiNotAssignedUsersReturned {
	const {
		data,
		isLoading,
	} = useQuery<IShortUserInfo[]>({
		queryKey: [GET_KAI_NOT_ASSIGNED_USERS, organisationId],
		queryFn: extractQueryParams(getKaiNotAssignedUsers),
	});

	return {
		kaiNotAssignedUsers: data || [],
		isLoadingKaiNotAssignedUsers: isLoading,
	};
}
